import React from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on every route change so new pages start at the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
